import React from 'react'
import moment from 'moment'
import trafficFineResultClean from '../../../assets/images/traffic_fine_result_clean.png'
import trafficFineResultWarning from '../../../assets/images/traffic_fine_result_warning.png'

export default function ResultCard({ isAPIError, isVehicleWarning, message, plateNumber, checkedAtText, checkedAtDate, violationCount }) {
  const finalCheckedText = checkedAtText || moment(checkedAtDate || new Date()).format('HH:mm, DD/MM/YYYY')

  const heroImg = isAPIError ? trafficFineResultWarning : isVehicleWarning ? trafficFineResultWarning : trafficFineResultClean
  const countText = typeof violationCount === 'number' ? String(violationCount).padStart(2, '0') : '01'

  const titleNode = isAPIError ? (
    message || 'Có lỗi xảy ra, vui lòng thử lại sau!'
  ) : isVehicleWarning ? (
    <>
      Phát hiện xe có <span className="traffic-fine-result-title-brand">{countText}</span> lỗi vi phạm
    </>
  ) : (
    <>
      Xe của bạn sạch như bảng điểm 10,
      <br />
      không có lỗi phạt nguội nào!
    </>
  )

  const pillTheme = isAPIError
    ? {
        fill: 'var(--bg-card-hover)',
        text: 'var(--text-secondary)',
        border: 'var(--border-default)'
      }
    : isVehicleWarning
    ? {
        fill: 'var(--warning-bg)',
        text: 'var(--warning-text)',
        border: 'var(--warning-text)'
      }
    : {
        fill: 'var(--success-bg)',
        text: 'var(--success-text)',
        border: 'var(--success-text)'
      }

  const pillBackground = `linear-gradient(${pillTheme.fill}, ${pillTheme.fill}) padding-box, linear-gradient(180deg, rgba(0,0,0,0) 0%, ${pillTheme.border} 50%, rgba(0,0,0,0) 100%) border-box`

  return (
    <div className="traffic-fine-result-card">
      <div className="traffic-fine-result-card-center">
        <div className="traffic-fine-result-hero-wrap">
          <img className="traffic-fine-result-hero-img" src={heroImg} alt="result" />
          <div className="traffic-fine-result-plate-pill" style={{ background: pillBackground }}>
            <span style={{ color: pillTheme.text }}>{plateNumber}</span>
          </div>
        </div>

        <div className="traffic-fine-result-title">{titleNode}</div>
        <div className="traffic-fine-result-time">Tra cứu lúc {finalCheckedText}</div>
      </div>
    </div>
  )
}
